export default [
  {
    path: '/:locale([en/]*)?/notice',
    name: 'Notice',
    component: () => import('@/views/notice/Index'),
    meta: {
      language: false,
      sitemap: {
        loc: '/notice'
      }
    }
  },
  {
    path: '/:locale([en/]*)?/notice/detail/:noticeId(\\d+)?',
    name: 'NoticeDetail',
    component: () => import('@/views/notice/Detail'),
    meta: {
      language: false,
      parent: 'Notice',
      sitemap: { ignoreRoute: true }
    }
  },
]
